/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-use-before-define */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/require-default-props */

// https://github.com/jossmac/react-images/blob/master/examples/src/components/Gallery.js

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import Lightbox from 'react-images';

class Gallery extends Component {
  constructor() {
    super();

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0,
    };

    this.closeLightbox = this.closeLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.gotoImage = this.gotoImage.bind(this);
    this.handleClickImage = this.handleClickImage.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
  }

  openLightbox(index, event) {
    event.preventDefault();
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
    });
  }

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  gotoImage(index) {
    this.setState({
      currentImage: index,
    });
  }

  handleClickImage() {
    if (this.state.currentImage === this.props.images.length - 1) return;

    this.gotoNext();
  }

  renderGallery() {
    const { images } = this.props;

    if (!images) return;

    const gallery = images.filter(i => i.useForDemo).map((obj, i) => {
      return (
        <a
          href={obj.src}
          className={css(classes.thumbnail, classes[obj.orientation])}
          key={i}
          onClick={(e) => this.openLightbox(i, e)}
        >
          <img src={obj.thumbnail} className={css(classes.source)} />
          <div className={css(classes.thumbnailCaptionContainer)}>
            <p className={css(classes.thumbnailCaption)}>{ obj.caption }</p>
          </div>
        </a>
      );
    });

    return (
      <div className={css(classes.gallery)}>
        {gallery}
      </div>
    );
  }

  render() {
    return (
      <div className="section">
        {this.props.heading && <h2>{this.props.heading}</h2>}
        {this.props.subheading && <p>{this.props.subheading}</p>}
        {this.renderGallery()}
        <Lightbox
          currentImage={this.state.currentImage}
          images={this.props.images}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.handleClickImage}
          onClickNext={this.gotoNext}
          onClickPrev={this.gotoPrevious}
          onClickThumbnail={this.gotoImage}
          onClose={this.closeLightbox}
          preventScroll={this.props.preventScroll}
          showThumbnails={this.props.showThumbnails}
          spinner={this.props.spinner}
          spinnerColor={this.props.spinnerColor}
          spinnerSize={this.props.spinnerSize}
          theme={this.props.theme}
        />
      </div>
    );
  }
}

Gallery.displayName = 'Gallery';

Gallery.propTypes = {
  heading: PropTypes.string,
  images: PropTypes.array,
  showThumbnails: PropTypes.bool,
  subheading: PropTypes.string,
};

const gutter = {
  small: 10,
  large: 14,
};

const classes = StyleSheet.create({
  gallery: {
    marginRight: -gutter.small,
    overflow: 'hidden',

    '@media (min-width: 768px)': {
      marginRight: -gutter.large,
    },
  },

  // anchor
  thumbnail: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'block',
    float: 'left',
    lineHeight: 0,
    paddingRight: gutter.small,
    paddingBottom: gutter.small,
    overflow: 'hidden',

    '@media (min-width: 768px)': {
      paddingRight: gutter.large,
      paddingBottom: gutter.large,
    },
  },

  thumbnailCaptionContainer: {
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    right: gutter.small,
    bottom: gutter.small,

    '@media (min-width: 768px)': {
      right: gutter.large,
      bottom: gutter.large,
    },

    opacity: 0,

    ':hover': {
      opacity: '1',
    },
  },

  thumbnailCaption: {
    display: 'block',

    backgroundColor: 'rgba(184,197,0,1)',
    color: '#fff',

    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    bottom: 0,

    margin: 0,
    padding: '.25em .5em',

    lineHeight: '1.4',

    fontWeight: 'bold',
    fontSize: '12px',

    '@media (min-width: 480px)': {
      fontSize: '14px',
    },
    '@media (min-width: 600px)': {
      fontSize: '18px',
    },
    '@media (min-width: 700px)': {
      fontSize: '20px',
    },
    '@media (min-width: 768px)': {
      fontSize: '14px',
    },
    '@media (min-width: 830px)': {
      fontSize: '16px',
    },
    '@media (min-width: 900px)': {
      fontSize: '18px',
    },
    '@media (min-width: 1100px)': {
      fontSize: '20px',
    },
  },

  // orientation
  landscape: {
    width: '49%',
    '@media (min-width: 768px)': {
      width: '33%',
    },
  },
  square: {
    paddingBottom: 0,
    width: '40%',

    '@media (min-width: 768px)': {
      paddingBottom: 0,
    },
  },

  // actual <img />
  source: {
    border: 0,
    display: 'block',
    height: 'auto',
    maxWidth: '100%',
    width: 'auto',
  },
});

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/SmartboardGallery/Gallery.js